import { render, staticRenderFns } from "./Productcenter.vue?vue&type=template&id=1829b2b0&scoped=true"
import script from "./Productcenter.vue?vue&type=script&lang=js"
export * from "./Productcenter.vue?vue&type=script&lang=js"
import style0 from "./Productcenter.vue?vue&type=style&index=0&id=1829b2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1829b2b0",
  null
  
)

export default component.exports